<div class="db-activities-list">
  <div class="db-activities-list__header db-activities-list__grid ds-hide-mobile">
    <p>User</p>
    <p>Type</p>
    <p>Action</p>
    <p>Date</p>
    <p>Status</p>
  </div>
  <div class="db-activities-list__body"
       [ngClass]="{'empty': !activities?.length, 'without-pagination': activities?.length <= itemsPerPage }"
       #activitiesListRef>
    <p *ngIf="!activities?.length">There are no activities based on your filters.</p>
    <div *ngIf="activities?.length">
      <div class="db-activities-list__header db-activities-list__grid ds-hide-desktop">
        <p>User</p>
        <p>Type</p>
        <p>Action</p>
        <p>Date</p>
        <p>Status</p>
      </div>
      <div class="db-activities-list__activity db-activities-list__grid"
           *ngFor="let activity of activities | pagination : {currentPage: currentPage, itemsPerPage: itemsPerPage}">
        <div class="db-activities-list__user">
          <p [innerHTML]="activity.userName | middleEllipsis: 40"></p>
          <sub [innerHTML]="activity.userEmail | middleEllipsis: 40"></sub>
        </div>
        <p class="db-activities-list__type"
           [innerHTML]="activity.type | middleEllipsis: 35"></p>
        <p class="db-activities-list__action" [innerHTML]="(activity.action | activitiesText : activity.placeholders)
         | middleEllipsis: 50"
           [dsTooltip]="actionRef" [dsTooltipVisible]="!isMobile && activity.action.length > 96" dsTooltipAlign="left"></p>

        <ng-template #actionRef>
          <p class="db-activities-list__action-full" [innerHTML]="activity.action | activitiesText : activity.placeholders"></p>
        </ng-template>

        <p class="db-activities-list__date" [innerHTML]="activity.date | date: 'MMM d, y, h:mm a'"></p>
        <p class="db-activities-list__status" [dsTooltip]="activity.success ? 'Success' : 'Failed'" dsTooltipPosition="bottom"
           dsTooltipSize="small" dsTooltipColor="black" dsTooltipAlign="right" [dsTooltipVisible]="!isMobile">
          <i class="db-icon db-icon-ds-{{activity.success ? 'checkmark-bg' : 'close-bg'}}"></i>
        </p>
      </div>
    </div>
  </div>
  <div *ngIf="activities?.length > itemsPerPage" class="db-activities-list__pagination">
    <ds-pagination-controls [rightNavigation]="!!isMobile" [itemsCount]="activities?.length" [itemsPerPage]="itemsPerPage"
                            [currentPage]="currentPage"
                            (onChangePage)="currentPage = $event; activitiesListRef.scrollTo(0, 0)"></ds-pagination-controls>
  </div>
</div>
